var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-block"},[_c('div',{staticClass:"goback1",on:{"click":_vm.goback}},[_c('span',{staticClass:"icon el-icon-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }